import "../../style/base.css";
import "../../badge/index.css";
import "../index.css";
